export default {
  getAllDocument: { is: 'Sækja öll skjöl', en: 'Download all documents' },
  quarter: { is: 'F', en: 'Q' },
};
